// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"287":"a0d21e55","605":"d84fc2c2","754":"d14d94db","859":"d4ccfb15","905":"27928e55","977":"4235dc23"}[chunkId] + ".js";
};